import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
const AddHsn = () => {
  const navigate = useNavigate();
  const [hsn, setHsn] = useState("");
  const [percentage, setpercentage] = useState("");

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const submitForm = async (e) => {
    e.preventDefault();
    const categoryobj = new FormData();

    categoryobj.append("hsc_code", hsn);
    categoryobj.append("gst_percent", percentage);
    axios
      .post("/api/create_hsn", categoryobj, {
        headers: {
          accept: "application/json",
        },
      })
      .then((result) => {
        Toast.fire({
          icon: "success",
          title: result.data.message,
        });

        navigate("/hsn");
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: error.response.data.message,
        });
      });
  };

  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-2 p-0">
            <Sidebar />
          </div>
          <div className="col-sm-10 ">
            <div className="container-fluid">
              <Navbar />
              <div className="p-2 bg-white">
                <span>
                  <Link to="/dashboard">Dashboard</Link> /{" "}
                  <Link to="/hsn">HSN</Link> / Add
                </span>
              </div>

              <div className="bg-gre p-60" style={{ minHeight: "570px" }}>
                <div className="main-box">
                  <h5>
                    <center className="mb-4 mt-3">
                      <b>Add New HSN</b>
                    </center>
                  </h5>
                  <div className="text-box">
                    <TextField
                      id="outlined-basic"
                      label="HSN"
                      variant="outlined"
                      className="input-field w-40 mb-3"
                      name="hsc_code"
                      type="text"
                      placeholder="HSN"
                      value={hsn}
                      onChange={(e) => setHsn(e.target.value)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9 ]/g, "");
                      }}
                    />
                    <TextField
                      // required
                      id="outlined-basic"
                      label="GST %"
                      variant="outlined"
                      className="input-field w-40 mb-3"
                      name="gst_percent"
                      type="text"
                      min="1"
                      defaultValue={0}
                      placeholder="%"
                      value={percentage}
                      onChange={(e) => {
                        const re = /^[0-9 \b]+$/;
                        if (
                          e.target.value === "" ||
                          (re.test(e.target.value) &&
                            parseFloat(e.target.value) <= 99)
                        ) {
                          setpercentage(e.target.value);
                        }
                      }}
                    />
                    <button
                      onClick={submitForm}
                      className="btn btn-danger mb-2"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddHsn;
